<template>
  <div>
    <div class="home">
      <div class="guide-header">
        <div class="guide-header-info">
          <div class="header-info-img">
            <img :src="img_uri">
          </div>
          <div class="header-info-content">
            <div class="info-content-name">
              <span class="">{{user_name}}</span>
              <img src="../assets/guideimg/jingying.svg">
            </div>
            <div class="info-company">洛阳中科基因有限公司</div>
            <ul>
              <li class="info-orgin">{{et_name}}</li>
              <li class="info-blue">从业{{dateNum}}年</li>
            </ul>
          </div>
        </div>
        <div class="guide-header-statistics">
          <div class="header-statistics">
            <div class="header-statistics-num"><span>{{focus_num}}</span>人</div>
            <div class="header-statistics-text">关注人数</div>
          </div>
          <div class="header-statistics">
            <div class="header-statistics-num"><span>{{consult_num}}</span>人</div>
            <div class="header-statistics-text">咨询人数</div>
          </div>
          <div class="header-statistics">
            <div class="header-statistics-num"><span>{{comment_ok_rate}}</span>%</div>
            <div class="header-statistics-text">好评率</div>
          </div>
        </div>
      </div>
      <div class="guide-inquiry">
        <div class="guide-inquiry-title">问诊方式</div>
        <div class="guide-inquiry-content">
          <div class="inquiry-box" @click="register">
            <div class="inquiry-img"><img src="../assets/guideimg/zixun.svg"></div>
            <div class="inquiry-title">图文问诊</div>
            <div class="inquiry-text">免费咨询</div>
          </div>
          <div class="inquiry-width"></div>
          <div class="inquiry-box" @click="register">
            <div class="inquiry-img"><img src="../assets/guideimg/video.svg"></div>
            <div class="inquiry-title">视频问诊</div>
            <div class="inquiry-text">¥10/次</div>
          </div>
        </div>
      </div>
      <div class="guide-major">
        <div class="guide-major-title">专业特长/学术成就</div>
        <ul>
          <li>{{skills}}</li>
        </ul>
      </div>
      <div class="guide-type">
        <div class="guide-type-title">擅长种类</div>
        <ul>
          <li v-for="(item,i) in classid" :key="i">{{item}}</li>
        </ul>
      </div>
      <div class="guide-treatment">
        <ul>
          <li v-for="(item,i) in treatment_skill" :key="i">{{item}}</li>
        </ul>
      </div>
      <div class="guide-line"></div>
      <div class="guide-evaluate">
        <div class="guide-evaluate-title">评价</div>
        <div class="evaluate-list">
          <div class="evaluate-box" v-for="(item,i) in comment" :key="i">
            <div class="evaluate-info">
              <div class="evaluate-name">{{item.submit_nick_name ? item.submit_nick_name : item.submit_name | strName}}</div>
              <div class="evaluate-date">{{item.insert_time | timeDate}}</div>
            </div>
            <div class="evaluate-text">{{item.contents}}</div>
            <ul>
              <li>{{item.service_name}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="guide-button" @click="register">
        <div class="guide-follow">
          <div class="follow">
            <img src="../assets/guideimg/follow.png">
            <span>关注</span>
          </div>
        </div>
        <div class="guide-video">
          <div class="consulting-but">
            <img src="../assets/guideimg/jiance.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { expertinfo } from '@/api/resetApi.js'
import { wxshare, classType, getDateYear } from '@/utils/utils.js'
export default {
  name: 'guide',
  data(){
    return{
      user_name: '',
      et_name: '',
      focus_num: '',
      consult_num: '',
      comment_ok_rate: '',
      img_uri: '',
      skills: '',
      treatment_skill: '',
      comment: [],
      classid: [],
      comment_num: '',
      dateNum: '',
      expert_id: '',
      ua: window.navigator.userAgent.toLowerCase(),
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      }
    }
  },
  created(){
    this.expert_id = this.$route.query.expertId
    this.expertInfo()
  },
  methods: {
    async expertInfo() {
      let data = new URLSearchParams();
      data.append('expert_id',this.expert_id)
      const res = await expertinfo(data)
      console.log(res)
      try {
        if (res.data.code === 1) {
          this.user_name = res.data.obj.info[0].user_name
          this.et_name = res.data.obj.info[0].et_name
          this.focus_num = res.data.obj.info[0].focus_num
          this.consult_num = res.data.obj.info[0].consult_num
          this.comment_ok_rate = res.data.obj.info[0].comment_ok_rate == 0 ? '100' : res.data.obj.info[0].comment_ok_rate
          this.img_uri = res.data.obj.info[0].img_uri
          this.skills = res.data.obj.info[0].skills ? res.data.obj.info[0].skills : '执业医师在线接诊/免费视频诊疗，专家经验丰富！'
          this.treatment_skill = (res.data.obj.info[0].treatment_skill ? res.data.obj.info[0].treatment_skill : '禽类普通病,畜类普通病,禽类寄生虫病,畜类中毒病').split(",")
          this.comment = res.data.obj.comment
          this.comment_num = res.data.obj.comment.length
          this.dateNum = getDateYear(res.data.obj.info[0].service_begin_year)
          this.classid = classType(res.data.obj.info[0].class_id.split(","))
          this.vetsName = this.user_name + '专家的个人主页'
          wxshare(this.img_uri,this.vetsName,this.skills);
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    register() {
      this.$router.push({
        name: 'register',
        query:{
          user_id: this.user_id,
        }
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  max-width: 780px;
  margin: 0 auto;
}
.guide-header {
  // width: 100%;
  height: 2rem;
  background-image: url(../assets/guideimg/Bitmap.png);
  background-repeat: no-repeat;
  background-size:100% 100%;
  font-size: 0;
  .guide-header-info {
    display: flex;
    padding: 0.35rem 0.15rem 0.2rem;
    color: #ffffff;
    .header-info-img  {
      flex: 0 0 0.7rem;
      img {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 50%;
      }
    }
    .header-info-content {
      flex: 1;
      align-self: center;
      margin-left: 0.15rem;
      text-align: left;
      .info-content-name {
        display: inline-block;
        span {
          font-size: 0.16rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          text-align: left;
          vertical-align: middle;
        }
        img {
          width: 0.2rem;
          height: 0.2rem;
          margin-left: 0.1rem;
          vertical-align: middle;
        }
      }
      .info-company {
        padding-top: 0.1rem;
        font-size: 0.14rem;
        color: #fff;
      }
      ul {
        padding: 0.1rem 0 0.05rem;
        li {
          display: inline-block;
          padding: 0.04rem;
          margin-right: 0.05rem;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: center;
          border-radius: 0.03rem;
        }
        .info-orgin {
          background: #F5A623;
        }
        .info-blue {
          background: #17D5AA;
        }
      }
    }
  }
  .guide-header-statistics {
    display: flex;
    padding-top: 0.1rem;
    color: #ffffff;
    .header-statistics {
      flex: 1;
      .header-statistics-num {
        font-size: 0.12rem;
        font-family: Helvetica;
        text-align: center;
        span {
          font-size: 0.2rem;
        }
      }
      .header-statistics-text {
        padding-top: 0.06rem;
        text-align: center;
        font-family: Helvetica;
        font-size: 0.14rem;
      }
    }
  }
}
.guide-inquiry {
  padding: 0.2rem 0.15rem;
  .guide-inquiry-title {
    font-size: 0.16rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: bold;
    text-align: left;
    color: #181818;
  }
  .guide-inquiry-content {
    display: flex;
    padding-top: 0.1rem;
    .inquiry-box {
      flex: 1;
      height: 1rem;
      border: 0.01rem solid #f1f1f1;
      border-radius: 0.08rem;
      font-size: 0;
      .inquiry-img {
        padding: 0.15rem 0 0.1rem;
        text-align: center;
        img {
          width: 0.24rem;
          height: 0.24rem;
        }
      }
      .inquiry-title {
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: bold;
        text-align: center;
        color: #181818;
      }
      .inquiry-text {
        padding-top: 0.1rem;
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #f14f4c;
      }
    }
    .inquiry-width {
      width: 0.1rem;
    }
  }
}
.guide-major {
  padding: 0.2rem 0.15rem;
  .guide-major-title {
    font-size: 0.16rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: bold;
    text-align: left;
    color: #181818;
  }
  ul {
    padding: 0.1rem 0;
    li {
      font-size: 0.12rem;
      line-height: 0.2rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #666666;
      i {
        display: inline-block;
        width: 0.05rem;
        height: 0.05rem;
        margin-right: 0.05rem;
        border-radius: 50%;
        background: #666666;
      }
    }
  }
}
.guide-type {
  padding: 0 0.15rem;
  font-size: 0;
  .guide-type-title {
    font-size: 0.16rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: bold;
    text-align: left;
    color: #181818;
  }
  ul {
    padding: 0.2rem 0 0.15rem;
    text-align: left;
    li {
      display: inline-block;
      margin: 0 0.2rem 0.05rem 0;
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 50%;
      border: 0.01rem solid #004ea2;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: bold;
      text-align: center;
      color: #004ea2;
      line-height: 0.3rem;
    }
  }
}
.guide-treatment {
  padding: 0 0.15rem;
  font-size: 0;
  .guide-treatment-title {
    font-size: 0.16rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: bold;
    text-align: left;
    color: #181818;
  }
  ul {
    padding: 0 0 0.2rem;
    text-align: left;
    li {
      display: inline-block;
      padding: 0.05rem 0.1rem;
      margin: 0 0.02rem 0.05rem 0;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #127be4;
      background: rgba(18,123,228,0.1);
      border-radius: 0.1rem;
    }
  }
}
.guide-line {
  width: 100%;
  height: 0.1rem;
  background: #f5f5f5;
}
.guide-evaluate {
  padding: 0 0.15rem;
  font-size: 0;
  .guide-evaluate-title {
    padding: 0.2rem 0;
    font-size: 0.16rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: bold;
    text-align: left;
    color: #181818;
  }
  .evaluate-list {
    padding-bottom: 0.7rem;
    .evaluate-box {
      padding-top: 0.1rem;
      border-bottom: 0.01rem solid #eee;
      .evaluate-info {
        display: flex;
        .evaluate-name {
          flex: 1;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: bold;
          text-align: left;
          color: #181818;
        }
        .evaluate-date {
          flex: 0 0 1.5rem;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: right;
          color: #b3b3b3;
        }
      }
      .evaluate-text {
        padding-top: 0.12rem;
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
      }
      ul {
        padding: 0.12rem 0;
        text-align: left;
        li {
          display: inline-block;
          padding: 0.02rem 0.1rem;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 500;
          text-align: center;
          color: #004ea2;
          border: 0.01rem solid #004ea2;
          border-radius: 10px;
        }
      }
    }
  }
}
.guide-bottom {
  padding-bottom: 0.7rem;
  img {
    width: 100%;
  }
}
.guide-button {
  position: fixed;
  bottom: 0;
  display: flex;
  width:3.9rem;
  padding: 0.1rem 0;
  background: #fff;
  font-size: 0;
  .guide-follow {
    flex: 0 0 1rem;
    padding: 0 0.2rem;
    .follow {
      width: 0.98rem;
      height: 0.42rem;
      line-height: 0.45rem;
      border-radius: 0.22rem;
      border: 0.01rem solid #ff716e;
      vertical-align: middle;
      img {
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: middle;
      }
      span {
        margin-left: 0.05rem;
        font-size: 0.16rem;
        font-weight: 500;
        color: #ff716e;
        vertical-align: middle;
      }
    }
  }
  .guide-video {
    flex: 1;
    text-align: center;
    .consulting-but {
      display: inline-block;
      width: 2rem;
      height: 0.46rem;
      img {
        width: 100%;
      }
    }
  }
}
</style>
